"use client";

import React from "react";
import { ArrowRight, TrendingUp, Target } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
const caseStudies = [{
  id: 1,
  client: "Baumfreundliche Baumbefestigung",
  industry: "Zertifizierte Baumbefestigung",
  deliverables: "Plattform-Sicherung",
  title: "Baumfreundliche Baumbefestigung für die Plattform",
  description: "Zertifizierte und baumschonende Verankerungssysteme für dauerhafte Plattformen ohne Beeinträchtigung des Baumwachstums.",
  image: "https://baumpflege-straesser.de/wp-content/uploads/2026/06/ChatGPT-Image-23.-Juni-2026-12_07_09.png?v=q7acc1g9hp",
  beforeValue: 0,
  afterValue: 12,
  metricLabel: "Bauhöhe (Meter)",
  link: "/BuildingAndSupportPage"
}, {
  id: 2,
  client: "Wunschbaumhaus Projekt",
  industry: "Baumhaus‑Design",
  deliverables: "Kinderbude → Gästezimmer",
  title: "Wunschbaumhaus – von rustikaler Kinderbude zum edlen Gästezimmer",
  description: "Umwandlung einer kleinen, rustikalen Baumkinderbude in ein luxuriöses Gästezimmer mit hochwertiger Ausstattung und nachhaltiger Bauweise.",
  image: "https://baumpflege-straesser.de/wp-content/uploads/2026/06/joe-ng-jg_frOZrkhE-unsplash-scaled.jpg?v=b5q67uhkgn",
  beforeValue: 15,
  afterValue: 100,
  metricLabel: "Schutzfaktor (%)",
  link: "/BuildingAndSupportPage"
}, {
  id: 3,
  client: "Gut Ahrensburg",
  industry: "Baumpflege & Sicherheit",
  deliverables: "Baumpflege",
  title: "Sicherung historischer Eichen",
  description: "Umfassende Totholzentfernung und Kroneneinkürzung zur Wiederherstellung der Verkehrssicherheit auf einem öffentlichen Gutshof.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642178/img/lead_gen_dashboard_clinic.png",
  beforeValue: 85,
  afterValue: 5,
  metricLabel: "Gefahrenindex (%)",
  link: "/CareAndPruningPage"
}, {
  id: 4,
  client: "Stadtgarten Hamburg",
  industry: "Wurzelstockentfernung",
  deliverables: "Fräsen & Forst",
  title: "Präzises Fräsen auf engstem Raum",
  description: "Effiziente Entfernung störender Baumstümpfe mittels Spezialfräse, um Platz für eine neue Gartenlandschaft ohne Flurschaden zu schaffen.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642178/img/analytics_dashboard_fintech.png",
  beforeValue: 40,
  afterValue: 95,
  metricLabel: "Nutzfläche (%)",
  link: "/FellingAndRootsPage"
}];
export default function TheArchive() {
  return <section data-section-id="226414" id="träume-im-baum-baustellenschutz" className="text-foreground relative overflow-hidden py-24 !bg-[rgba(247,245,241,1)]">
      {}
      <div className="pointer-events-none absolute top-0 left-1/4 h-[500px] w-[500px] -translate-x-1/2 -translate-y-1/2 rounded-lg bg-primary/10 blur-[100px]" />
      <div className="pointer-events-none absolute right-0 bottom-0 h-[400px] w-[400px] translate-x-1/3 translate-y-1/3 rounded-lg bg-primary/5 blur-[100px]" />

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="mb-16 flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <h2 className="font-default mb-4 text-4xl font-bold tracking-tight md:text-5xl lg:text-6xl">
              Träume im <span className="text-primary">Baum</span>
            </h2>
            <p className="text-muted-foreground text-lg md:text-xl">
              Ein Einblick in unsere präzisen Baumpflege-Projekte und exklusiven Baumhaus-Konstruktionen. Wir dokumentieren Qualität und Sicherheit.
            </p>
            <p className="text-muted-foreground mt-4 text-lg md:text-xl">
              Wir bauen neue Baumhäuser jeder Art, von rustikalen/einfachen Kinderparadiesen bis zu edlen isolierten und beheizten Gäste/Arbeitszimmern im Baum.
            </p>
          </div>
          <Link to="/">
            
          </Link>
        </div>

        <div className="mb-12 overflow-hidden rounded-xl">
          <img src="https://baumpflege-straesser.de/wp-content/uploads/2026/06/stefanie-poepken-ar_CKost4J4-unsplash-scaled.jpg" data-wvc-srcset="https://balanced-monster.10web.cloud/wp-content/uploads/2026/05/ChatGPT-Image-5.-Mai-2026-10_34_34.png-wvc-srcset" data-wvc-sizes="https://balanced-monster.10web.cloud/wp-content/uploads/2026/05/ChatGPT-Image-5.-Mai-2026-10_34_34.png-wvc-sizes" alt="Baumhaus Konstruktion" className="w-full object-contain" loading="lazy" decoding="async" />
        </div>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
          {caseStudies.slice(0, 2).map((study, i) => {
          return <Card key={study.id} data-index={i} className="border-border/40 bg-card/40 group relative overflow-hidden backdrop-blur-md transition-all duration-500 hover:border-primary/50 hover:shadow-2xl hover:shadow-primary/10">
                {}
                <div className="bg-muted relative h-64 w-full overflow-hidden border-b border-border/40">
                  <img src={study.image} alt={`${study.client} Projekt-Dokumentation`} className="h-full w-full object-cover transition-all duration-700 group-hover:scale-105 group-hover:blur-0" />
                  <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/20 to-transparent transition-opacity duration-500 group-hover:opacity-80" />
                  
                  {}
                  <div className="absolute bottom-4 left-6 flex flex-wrap gap-2">
                    <span className="bg-background/95 text-foreground border-border/50 rounded-md border px-3 py-1 text-xs font-mono font-bold uppercase tracking-wider backdrop-blur-md">
                      {study.industry}
                    </span>
                  </div>
                </div>

                <CardHeader className="pt-8 pb-2">
                  <div className="mb-2 flex items-center gap-2 text-sm font-bold text-primary">
                    <Target className="h-4 w-4" />
                    <span className="font-mono tracking-tight">{study.deliverables}</span>
                  </div>
                  <CardTitle className="font-default text-2xl font-bold md:text-3xl text-foreground">
                    {study.title}
                  </CardTitle>
                  <CardDescription className="text-foreground/70 mt-2 text-base leading-relaxed">
                    {study.description}
                  </CardDescription>
                </CardHeader>

                <CardFooter className="pt-0">
                  <Link to={study.link} className="w-full">
                    
                  </Link>
                </CardFooter>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}